import { /* AddIcon, */ CancelOrderIcon, /* SubtractIcon */ } from "../../../../assets";
import styles from "./style.module.css"

export interface ICartItemQuantity{

  handleClick: (index: number) => void
  index: number;
}

export const CartItemQuantity = ({handleClick, index} : ICartItemQuantity) =>{

  // const handleClick = () => {
  //   // window.open("https://www.example.com", "_blank"); // Replace with the desired URL
  //   console.log("Clicked Circle");
  // };

     return (
       <div className={styles.container}>
         {/* CartItemQuantity */}
         <div className={styles.circle} onClick={()=>{
          handleClick(index);
         }}>
           <CancelOrderIcon />
         </div>

         

         {/* <div className={styles.text}>Quantity :</div>

         <div className={styles.rectangle}>
           <div className={styles.part}>
            <AddIcon/>
           </div>
           <div className={styles.part}>
            1
           </div>
           <div className={styles.part}>
            <SubtractIcon />
           </div>
         </div> */}

         
       </div>
     );

}